import { HttpError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import InvoiceStats, { InvoiceStatsDto } from "./InvoiceStats"
import QuoteStats, { QuoteStatsDto } from "./QuoteStats"

export default class StatsService {
    static invoicesHttpClient: HttpClient<InvoiceStats, InvoiceStatsDto>
        = new HttpClient<InvoiceStats, InvoiceStatsDto>(InvoiceStats)
        
    static async GetInvoiceStats(): Promise<InvoiceStats | InvoiceStats[] | HttpError> {
        return this.invoicesHttpClient.get("/stats/invoices")
    }

    static quotesHttpClient: HttpClient<QuoteStats, QuoteStatsDto>
        = new HttpClient<QuoteStats, QuoteStatsDto>(QuoteStats)
        
    static async GetQuoteStats(): Promise<QuoteStats | QuoteStats[] | HttpError> {
        return this.quotesHttpClient.get("/stats/quotes")
    }
}


// WEBPACK FOOTER //
// ./src/state/stats/StatsService.ts